import BidtheatreSummaryStats from '@/shared/components/advertisement-info/BidtheatreSummaryStats';
import BidtheatrePreviewSummary from '@/shared/components/platform-previews/previews/bidtheatre/BidTheatrePreviewSummary';
import { IFullAdvertisementModel } from '@/shared/models/advertisements/full-advertisement-model';
import { useAppSelector } from '@/store/hooks/redux';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FC, type JSX } from 'react';
import SectionHeader from '../SectionHeader';
import DatesBreakDown from '../DatesBreakdown';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@/store/hooks/redux';
import { setBidtheatreShareLink } from '@/editor/store/reducers/property-info.slice';
import CreativeTypesEnum, { CreativeType } from '@/editor/shared/constants/creatives-types.enum';
import { AvailablePlatformsEnum } from '@/editor/shared/constants/available-platforms';

export interface IEieBidtheatreSectionProps {
  advertisement: IFullAdvertisementModel;
  extCompanyId: string;
  profileTitle?: string | null;
  profileImage?: string | null;
}

const EieBidtheatreSection: FC<IEieBidtheatreSectionProps> = ({
  advertisement: { advertisementStats },
  advertisement,
  extCompanyId,
  profileTitle = '',
  profileImage = '',
}): JSX.Element => {
  const { t } = useTranslation();

  const creativeFormsState = useAppSelector((state) => state.creativeStepSliceReducer.creativeFormsState);
  const creativeType =
    advertisement.creative.creativeType === CreativeTypesEnum.CAROUSEL
      ? CreativeTypesEnum.SINGLE
      : advertisement.creative.creativeType;
  const currentCreativeForm = creativeFormsState[AvailablePlatformsEnum.BIDTHEATRE][creativeType as CreativeType];
  const dispatch = useAppDispatch();
  dispatch(setBidtheatreShareLink(advertisementStats.bidtheatreStats?.campaignScreenshots?.fileurl!));

  return (
    <div>
      <Card sx={{ width: '100%' }}>
        <SectionHeader
          platform={'bidtheatre'}
          totalClicks={advertisementStats?.bidtheatreStats?.totalClicks ?? 0}
          totalImpressions={advertisementStats?.bidtheatreStats?.totalImpressions ?? 0}
        />
        <CardContent>
          <Grid container>
            <Grid item xs={12} md={5}>
              <BidtheatrePreviewSummary
                externalCompanyId={extCompanyId}
                values={currentCreativeForm!}
                profileTitle={profileTitle}
                profileImage={profileImage}
                selectedType={advertisement.creative.creativeType as CreativeType}
              />
            </Grid>
            {advertisementStats.bidtheatreStats?.totalClicks! > 0 ? (
              <Grid item xs={12} md={6} mx={'auto'}>
                <DatesBreakDown
                  datesBreakdown={advertisementStats?.bidtheatreStats?.datesBreakdown!}
                  externalCompanyId={extCompanyId}
                />
                <Divider sx={{ my: 2 }} />
                <BidtheatreSummaryStats
                  bidtheatreStats={advertisementStats?.bidtheatreStats!}
                  externalCompanyId={extCompanyId}
                />
              </Grid>
            ) : (
              <Grid item xs={12} m={2} md={6} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <Typography m={2} variant="h2">
                  {t('adWithNoStats')}
                </Typography>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default EieBidtheatreSection;
